// extracted by mini-css-extract-plugin
export default {"model-viewer-wrapper":"modelviewer_model-viewer-wrapper__ZBBbH","model-viewer":"modelviewer_model-viewer__bMuar","footer":"modelviewer_footer__pAOu0"};